import {
  CommunicationCampaignDispatchStatus,
  CommunicationCampaignRevenueInDTO,
  CommunicationCampaignState,
} from '../campaign.type';

type DispatchStatusSource = Pick<CommunicationCampaignRevenueInDTO, 'isScheduled' | 'dispatchStatus' | 'state'>;

// A send-now campaign can still read SCHEDULED once dispatched; both histories show it as sent.
export const displayedDispatchStatus = ({
  isScheduled,
  dispatchStatus,
  state,
}: DispatchStatusSource): CommunicationCampaignDispatchStatus =>
  !isScheduled &&
  dispatchStatus === CommunicationCampaignDispatchStatus.SCHEDULED &&
  state === CommunicationCampaignState.VALID
    ? CommunicationCampaignDispatchStatus.SENT
    : dispatchStatus;
